import { Filters } from '@components/filters';

import { useStore } from 'models/Provider';

export function FilterActionButtons({ disableApply }: { disableApply: boolean }) {
  const { t } = useStore();

  return (
    <Filters.Actions
      disableApply={disableApply}
      applyFilterText={t('filters.apply')}
      updateFilterText={t('filters.update')}
      removeFilterText={t('filters.remove')}
    />
  );
}
